import { ICourse } from 'interface/course';
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

export const useFacebookPixel = (course: ICourse) => {
  useEffect(() => {
    if (!course || !course.fc_pixel) return;
    ReactPixel.init(course.fc_pixel);
    ReactPixel.pageView();
  }, [course]);
};
